import { ItemCardDetails } from "@/components/ItemCard";
import { type NormalizedDrawing } from "@repo/api";
import { LightMode } from "@repo/skapa";
import { t } from "@repo/translation";
import { LocalizedDateAndTime, SimpleLabelField } from "@repo/ui";

import { PlannerDrawingLabel } from "../PlannerDrawingPill";

interface DrawingCardDetailsProps {
  drawing: NormalizedDrawing;
}
export const DrawingCardDetails = ({ drawing }: DrawingCardDetailsProps) => {
  return (
    <ItemCardDetails
      title={drawing.name}
      description={<PlannerDrawingLabel drawingInfo={drawing} />}
      addOn={
        <div>
          <SimpleLabelField
            small
            label={t("label.type")}
            value={drawing.type}
            color={LightMode.colourTextAndIcon2}
          />
          <SimpleLabelField
            small
            label={t("label.created")}
            value={<LocalizedDateAndTime date={drawing.created ?? ""} />}
            color={LightMode.colourTextAndIcon2}
          />
          <SimpleLabelField
            small
            label={t("label.updated")}
            value={<LocalizedDateAndTime date={drawing.updated ?? ""} />}
            color={LightMode.colourTextAndIcon2}
          />
        </div>
      }
    />
  );
};
